import inview from './inview';
import sticky from './sticky';
import slider from './slider';

export default {
    init() {
        inview.init()
        sticky.init()
        slider.init()

        this.loadBannerAnimation()
        this.backToTop()
        this.deviceCheck()
        this.animateLinks()

        if( $('.offcanvas').length ){
            this.offcanvasToggle()
        }
    },

    animateLinks(){
       $("a[href^=#]:not(.burger-toggle)").click(function(e) {
          e.preventDefault();
          var dest = $(this).attr('href');
          $('html,body').animate({ scrollTop: $(dest).offset().top }, 'slow');
       });
    },

    deviceCheck(){
        if (navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|IEMobile)/)) {
            $('body').addClass('is-mobile')
        } else {
            $('body').addClass('is-desktop')
        }
    },

    backToTop(){
        $('.back-to-top').click(function (e) {
            e.preventDefault()
            $("html, body").animate({scrollTop: 0}, 1000);
        });
    },


    loadBannerAnimation(){
        setTimeout(function(){
            $('.page-header').addClass('page-header--active')
            $('.page-header__text').addClass('el-iv')

            if( $('.service-links__item').length ){
                $('.service-links__item').addClass('el-iv')
            }
        }, 500);
    },

    offcanvasToggle(){
        const self = this

        $('.burger-toggle').click(function(e) {
            e.preventDefault()

            if( $('.burger-toggle').hasClass('burger-toggle--active') ) {
                self.navDeactivate()
            } else {
                self.navActivate()
            }
        })
    },

    navActivate(){
        setTimeout(function () {
            $('.burger-toggle').addClass('burger-toggle--active')
        }, 300)

        $('body').addClass('offcanvas-active')
    },

    navDeactivate(){
        $('body').removeClass('offcanvas-active')

        setTimeout(function () {
            $('.burger-toggle').removeClass('burger-toggle--active')
        }, 200)
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js